An array of child job categories.

These are more specific categories that belong to this general classification.
